import { Directive, inject, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { DynamicDialogConfig } from "primeng/dynamicdialog";
import { DialogFooterHostComponent } from "./dialog-footer-host.component";

@Directive({
    selector: "[kno2DialogFooter]"
})
export class DialogFooterDirective implements OnInit {
    private readonly templateRef = inject(TemplateRef);
    private readonly viewContainerRef = inject(ViewContainerRef);
    private readonly config = inject(DynamicDialogConfig, { optional: true });

    public ngOnInit(): void {
        if (this.config) {
            (this.config.data ??= {}).kno2FooterTemplate = this.templateRef;
            this.config.templates = { ...this.config.templates, footer: DialogFooterHostComponent };
        } else {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }
}
